<template>
 <div>
   <div class="form-floating position-relative">
    <vue3-simple-typeahead
    v-if="reloadTypehead"
    class="form-control fs-xl-2 text-center"
    id="typeahead_documentos_clientes"
    :items="documentosClientes"
    :itemProjection="adaptiveProjection"
    :minInputLength="1"
    :defaultItem="documento"
    @onInput="getDocumentos"
    @selectItem="selectItem">
   </vue3-simple-typeahead>
   <div class="d-flex loader-input-document">
    <i v-if="search && !loaderInputDocumento" title="Click para buscar cliente" 
    class="fa-solid fa-magnifying-glass c-pointer" @click="activeSearchClienteModal = true"></i>
    <span v-if="loaderInputDocumento" class="spinner-border spinner-border-sm c-wait" role="status"></span>
   </div>
  
   <label for="floatingInput3" :class="required ? 'field-required' : ''">{{title ? title : 'Documento'}}</label>
  </div> 

  <ModalSearchCliente class="animate__animated animate__fadeIn animate__faster" 
  :modo="1" 
  @toggleModalFiltradoClientes="activeSearchClienteModal = !activeSearchClienteModal"
  @dataClienteFilter="setClienteFiltrado($event)" 
  v-if="activeSearchClienteModal"/>
</div>
</template>

<script setup>
import {ref, watch} from 'vue'
import {getDocumentosClientes} from '@/helpers'
const reloadTypehead = ref(true)

const props = defineProps({
    title: '',
    documento: '',
    required: '',
    search: Boolean
})

const emit = defineEmits(['selected'])
const activeSearchClienteModal = ref(false)
const loaderInputDocumento = ref(false)
const documentosClientes = ref([])
const currentSearch = ref('')


const getDocumentos = async (e) => {
    currentSearch.value = e.input
    loaderInputDocumento.value = true
    const response = await getDocumentosClientes(e.input) 
    loaderInputDocumento.value = false 
    if(response.data.length == 0){
        documentosClientes.value = []
        emit('selected', {id: null, documento: e.input})
    }else{
        documentosClientes.value = response.data
    }
}

const adaptiveProjection = (item) => {
    if (!item) return '';
    const q = currentSearch.value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const doc = (item.documento || '').toLowerCase();
    const nombres = (item.nombres || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const apellidos = (item.apellidos || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const fullName = `${nombres} ${apellidos}`;

    // If query matches document, show document
    if (doc.includes(q)) return item.documento;
    // If query matches name, show name
    if (fullName.includes(q)) return `${item.nombres} ${item.apellidos}`;
    
    return item.documento;
}

const selectItem = (item) => {
    emit('selected', item);
    // After selection, we want the input to show the document number
    setTimeout(() => {
        const input = document.querySelector('#typeahead_documentos_clientes');
        if (input) input.value = item.documento;
    }, 50);
}


const reloadInput = () => {
    reloadTypehead.value = false
    setTimeout(() => {
    reloadTypehead.value = true
   }, 50);
}


const setClienteFiltrado = (data) => {
   emit('selected', data)
}


watch(() => props.documento.documento, newVal => {
    if (newVal) {
        reloadInput();
    }
});
</script>

<style scoped>
.loader-input-document{
    position:absolute; 
    top: 0.8rem; 
    right: 1rem; 
    padding: 0.6rem;
}

.c-wait{
    cursor: wait;
}
</style>